import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import Layout from '../../../components/layout';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import { PencilIcon } from '@heroicons/react/solid';
import HomeDistrict from '../../../api/models/homeDistrict';
import { getHomeDistricts } from '../../../api/services/homeDistrictService';

type ViewState = {
  message?: string;
};

const ViewHomeDistricts = () => {
  const columns = React.useMemo(
    () => [
      {
        id: 'districtColumn',
        Header: 'Home District',
        accessor: 'name',
      },
      {
        Header: 'City',
        accessor: (d: any) => d.city
      },
      {
        Header: 'County',
        accessor: (d: any) => d.county,
      },
      {
        Header: 'State',
        id: 'stateColumn',
        accessor: (d: any) => d.state,
      },
      {
        accessor: 'homeDistrictId',
        disableSortBy: true,
        Cell: (props: any) => {
          return (
            <div className='clearfix'>
              <span className='float-right'>
                <PencilIcon
                  className='w-5 h-5 cursor-pointer'
                  aria-hidden='true'
                />
              </span>
            </div>
          );
        },
        className: 'hidden sm:table-cell',
      },
    ],
    []
  );
  const defaultSort = React.useMemo(
    () => [
      {
        id: "stateColumn",
        desc: false
      }
    ],
    []
  );
  const history = useHistory();
  const { state } = useLocation<ViewState>();
  const [homeDistricts, setHomeDistricts] = useState<HomeDistrict[]>([]);
  const [initialState, setInitialState] = useState<{}>({ sortBy: defaultSort, sortType: "ci" });

  const { error, isPending } = useAsync({
    promiseFn: getHomeDistricts,
    onResolve: (r) => setHomeDistricts(r.data)
  });

  if (error) return <LayoutError />;

  return (
    <Layout isLoading={isPending}>
      <Fragment>
        {state?.message && <Notification>{state?.message}</Notification>}

        <div className='mb-4 text-right'>
          <Link className='btn' to='/admin/homeDistricts/new'>
            Add Home District
          </Link>
        </div>

        <DataTable
          columns={columns}
          data={homeDistricts}
          initialState={initialState}
          showPagination={true}
          getRowProps={(row: any) => ({
            className: row.original.isMyMessage
              ? 'cursor-pointer hover:bg-purple-300 bg-purple-200'
              : 'cursor-pointer hover:bg-gray-100',
            onClick: () =>
              history.push(`/admin/homeDistricts/${row.values.homeDistrictId}`),
          })}
        />
      </Fragment>
    </Layout>
  );
};

export default ViewHomeDistricts;
